const blog = {
  getlist: 'blog/getlist-by-admin',
  add: 'blog/add',
  update: 'blog/update',
  remove: 'blog/remove',
  get: 'blog/get-by-admin',
  getall: 'blog/getall',
  removeLanguageInfo: 'blog/removeinfo',
  addLanguageInfo: 'blog/addinfo',
  editLanguageInfo: 'blog/editinfo',
}
export default blog
